import { motion } from "framer-motion";
import { itemUp } from "../Utils/framerMotionVariants";
import { Education } from "../data/education";

const EducationCard: React.FC<{ education: Education }> = ({ education }) => {
  return (
    <motion.div
      variants={itemUp}
      className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-sm"
    >
      <div className="flex items-start justify-between">
        <div>
          <h3 className="font-medium">{education.degree}</h3>
          <p className="text-sm text-gray-300">{education.university}</p>
        </div>
        <div className="text-sm text-gray-400">{education.period}</div>
      </div>
      <ul className="mt-3 list-disc list-inside text-sm text-gray-300">
        {education.bullets.map((b, idx) => (
          <li key={idx}>{b}</li>
        ))}
      </ul>
    </motion.div>
  );
};

export default EducationCard;
